module.exports = __webpack_public_path__ + "img/head-shoulders.1b3f6cec.png";